import { useAuthStore } from '@/hooks/useStore';

export interface AuthOwnerSnapshot {
  token: string | null;
  userId: string | null;
  isAuthenticated: boolean;
}

export function currentAuthOwner(): AuthOwnerSnapshot {
  const { token, user, isAuthenticated } = useAuthStore.getState();
  return { token, userId: user?.id ?? null, isAuthenticated };
}

export function sameAuthOwner(left: AuthOwnerSnapshot, right: AuthOwnerSnapshot): boolean {
  return (
    left.token === right.token &&
    left.userId === right.userId &&
    left.isAuthenticated === right.isAuthenticated
  );
}
